/**
 * 品牌 Logo 的读取规范
 *
 * 登录页支持最多 3 个 Logo 并排（学校 + 院系 + 合作方这类场景）。
 * 配置里的新字段是 `logos` 数组，老字段 `logo` 是单个字符串。
 *
 * 两种形状随时可能同时出现：
 *   - 老站 settings 表里存的还是只有 logo 的那份 JSON；
 *   - 用户浏览器 localStorage 里缓存的是上一版前端写进去的对象；
 *   - 前后端分开部署时，中间会有一小段"后端已更新、前端还没更新"的窗口。
 * 所以凡是读 Logo 的地方一律走这个函数，别直接摸字段。
 */

export const MAX_LOGOS = 3;

export function getLogos(branding) {
  if (!branding) return [];
  const list = Array.isArray(branding.logos) ? branding.logos : [];
  const cleaned = list.filter(url => typeof url === 'string' && url.trim());
  if (cleaned.length) return cleaned.slice(0, MAX_LOGOS);
  // 兜底到老字段
  return branding.logo ? [branding.logo] : [];
}

/* ────────────────────────────────────────────────────────────
 * 品牌配置的 localStorage 缓存（首屏免闪烁用）
 *
 * ⚠️ key 必须带站点标识。主站和教育版是两个**完全独立**的站，各自的
 * settings 表里 appName / Logo 都不一样。老版本用的是全站共用的
 * 'cineart_branding'，同一个浏览器先开主站再开教育版，第二个站首屏会
 * 短暂显示第一个站的 Logo 和名字，直到 API 返回才纠正。
 *
 * 这里按 host 拆 key。老 key 只删不读 —— 读了就等于把串站问题原样搬过来；
 * 代价只是老用户第一次打开时少一次缓存命中（首屏用 index.html 兜底标题），
 * 之后就写进新 key 了。
 * ──────────────────────────────────────────────────────────── */

const LEGACY_CACHE_KEY = 'cineart_branding';

export function brandingCacheKey() {
  const host = typeof window !== 'undefined' ? window.location.host : '';
  return `${LEGACY_CACHE_KEY}:${host}`;
}

export function readBrandingCache() {
  try {
    // 顺手清掉老的共用 key，别留着串站
    if (localStorage.getItem(LEGACY_CACHE_KEY)) localStorage.removeItem(LEGACY_CACHE_KEY);
    const cached = localStorage.getItem(brandingCacheKey());
    if (cached) return JSON.parse(cached);
  } catch { /* 隐私模式 / 解析失败都当没缓存 */ }
  return null;
}

export function writeBrandingCache(data) {
  try {
    localStorage.setItem(brandingCacheKey(), JSON.stringify(data));
  } catch { /* quota / 隐私模式，缓存不是必需品 */ }
}
